import * as React from "react";
import { Switch } from "react-router-dom";
import DashboardOverview from "../DashboardOverview/DashboardOverview";
import DashboardLayout from "../DashboardLayout";
import DashboardConfiguration from "../DashboardConfiguration/DashboardConfiguration";
import { RouteComponentProps } from "react-router";
import { renderWithLayout } from "components/RenderWithLayout/RenderWithLayout";
import ReloadableRoute from "components/ReloadableRoute/ReloadableRoute";
import routeLinks from "../../../routeLinks";
import pageIds from "pageIds";
import { withPage } from "components/Page/Page";

const dashboardConfiguration = renderWithLayout(DashboardLayout)(DashboardConfiguration);

const DashboardConfigurationPage = withPage({ page: pageIds.dashboard.configure })(dashboardConfiguration);
const DashboardOverviewPage = withPage({ page: pageIds.dashboard.root })(DashboardOverview);

const DashboardRoutes: React.StatelessComponent<RouteComponentProps<{}>> = (props) => {
    return (
        <Switch>
            <ReloadableRoute path={routeLinks.dashboard.configure} component={DashboardConfigurationPage} />
            <ReloadableRoute path={routeLinks.dashboard.root} component={DashboardOverviewPage} />
        </Switch>
    );
};

export default DashboardRoutes;
